<ui-button
  icon="griddy-close"
  [isDarkMode]="isDarkMode()"
  [variant]="border() ? 'tertiary' : 'quaternary'"
  [size]="size()"
  (onClick)="onClick.emit()"></ui-button>
